import CashFlow from "assets/images/financial-video-assets/cashflow.svg";
import BalanceSheet from "assets/images/financial-video-assets/balancesheet.svg";
import IncomeStatement from "assets/images/financial-video-assets/incomestatement.svg";
import TaxReturns from "assets/images/financial-video-assets/taxreturns.svg";
import AgingReports from "assets/images/financial-video-assets/agingreports.svg";
import Shareholders from "assets/images/financial-video-assets/statementofshareholders.svg";

export const TripleGridData = [
  {
    head: "Cash Flow Statements",
    image: CashFlow,
    content:
      "You can rest assured your information on your business' cash flow statements will be safely and securely translated through our financial translation.",
  },
  {
    head: "Balance Sheet",
    image: BalanceSheet,
    content:
      "Balance sheets are part and parcel of the finance sections of every business. All finance translations usually translate document translations, such as balance sheets.",
  },
  {
    head: "Income Statement (Profit and loss statement)",
    image: IncomeStatement,
    content:
      "Your profit and loss statements can find financial translation solutions, at Tomedes. We can find languages that fit your or your business' income statement.",
  },
  {
    head: "Tax Returns",
    image: TaxReturns,
    content:
      "You'll find global translators to translate your tax returns, who know the government regulations for your country, so you'll have accurately translated tax returns.",
  },
  {
    head: "Aging Reports",
    image: AgingReports,
    content:
      "Specific deliverables on your aging reports, as well as your comprehensive accounts receivable aging, can be translated into more than one language in detail at Tomedes.",
  },
  {
    head: "Statement of Shareholders Equity",
    image: Shareholders,
    content:
      "Your business' statement of shareholders equity is an important financial document that necessitates transparency in terms of translations. For that, you can count on Tomedes.",
  },
];

export const TripleGridData2 = [
  {
    firstHead: "Secure",
    head: "Project Management",
    lastHead: " ",
    imagE: " ",
    content:
      "The Tomedes financial translation process is managed by your personal account manager and executed by expert translators and editors, all bonded contractually by non-disclosure agreement to ensure strict adherence to all security and confidentiality provisions.",
  },
  {
    firstHead: "Financial",
    head: "Translation Process",
    lastHead: " ",
    imagE: " ",
    content:
      "Financial translation demands domain-specific expertise in the terminology and formats of the various fields of finance. Your project will be assigned to translators who possess the specific expertise that you require, including familiarity and adherence to best practices in your jurisdiction.",
  },
  {
    firstHead: "LQA",
    head: " ",
    lastHead: " ",
    imagE: " ",
    content:
      "In financial translation, linguistic quality assurance can be measured by an exacting process of linguistic quality analysis. This involves submitting all translation to testing and measurement to evaluate each translated work according to industry standards of measurement.",
  },
  {
    firstHead: " ",
    head: "Financial Terminology",
    lastHead: "Review",
    imagE: " ",
    content:
      "The quality assurance process for each financial translation involves the application of an industry-specific review which emphasizes and focuses on specific types of documents in the finance fields, including domains like banking, accountancy and insurance.",
  },
  {
    firstHead: "Industry-Specific",
    head: "Review",
    lastHead: " ",
    imagE: " ",
    content:
      "Industry specific reviews for the financial translation that Tomedes performs also takes into account the specific profession or industry. Financial documents required for the automotive industry, for example, differ from those for technology companies.",
  },
];

export const FinancialData = [
  {
    FirstWhite: " ",
    title: "Financial Translation Services",
    ColorHead: "Secure",
    detail:
      "Tomedes ensures strict compliance with security regulations on our website and in our communication. All our communications are encrypted with end-to-end encryption, and all our project managers and translators are bound by NDAs, all to ensure total privacy, confidentiality, and security.",
  },
  {
    FirstWhite: "Financial Translation Services Done by",
    title: "in Finance",
    ColorHead: "Experts",
    detail:
      "Our financial translation service is performed by our global teams, trained and certified translators in the field of financial translations, many of them specializing in finance-related fields and fully familiar with the terminology and jargon of diverse domains such as accountancy, banking, and insurance.",
  },
  {
    FirstWhite: "",
    title: "Solutions Capable of Handling Large Volume of Projects",
    ColorHead: "Scalable",
    detail:
      "Our financial translation services are performed by experts who are hand-picked by Tomedes from every timezone of the world, so that your financial translation can be done in a timely manner. Our combination of technological and human solutions are capable of handling large volumes of projects in no time at all.",
  },
  {
    FirstWhite: "",
    title:
      "  Translation Technology Making Sure Your Projects Are Delivered On-Time",
    ColorHead: "Up-to-date",
    detail:
      "Tomedes financial translation services combine human linguistic expertise with the most advanced technological applications to ensure the most efficient and cost-effective delivery of your time-sensitive projects. We provide state-of-the-art machine translation with smart human post-editing, tailor-fitted for you.",
  },
];

export const FinancialDataSec = [
  {
    heading: "Japanese",
    detail:
      "Japanese financial translation is a necessity in the business world, especially for the industry of finance. At Tomedes, Japanese native translators are sure to translate your financial documents.",
    link: "/japanese-to-english-translation-service.php",
  },
  {
    heading: "Korean",
    detail:
      "Of the majority of languages, Korean is one of the most marketable languages in the business world, and financial translation in Korean can meet the requirements of the Korean government.",
    link: "/english-to-korean-translation-service.php",
  },
  {
    heading: "French",
    detail:
      "French is one of the major European languages, with applications worldwide. French to English financial translation can accommodate government regulations everywhere that French is spoken.",
    link: "/french-to-english-translation-service.php",
  },
  {
    heading: "Arabic",
    detail:
      "Arabic is spoken in about 25 countries, which has specific regulations for Arabic financial institutions. Our financial translations can bridge the gap between you and your regulators.",
    link: "/arabic-translation.php",
  },
  {
    heading: "Spanish",
    detail:
      "Spanish is one of the most-spoken languages in the world, and Tomedes' financial translations can help you transact better between those countries and your country of origin.",
    link: "/english-to-spanish-translation-service.php",
  },
  {
    heading: "Chinese",
    detail:
      "Another popular business language in the world is Chinese, and financial matters have a heavy occurrence in this language. We specialize in both simplified and traditional Chinese, accounting for almost all dialects.",
    link: "/english-to-chinese-translation-service.php",
  },
];
